import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { createPopup } from '@maersk-global/insightshub-embed-common';
import { environment } from '../../../environments/environment';
import { AuthHelper } from '../../auth/auth-helper';
import { ApprovalFilterForm, WorkOrderFilterForm } from '../../form-model/work-order-filter.form.model';
import { WorkOrderSearchTextForm } from '../../form-model/work-order-search-text.form.model';
import { BulkWorkOrderCompletionBody } from '../../models/bulk-work-order/bulk-work-order-completion.model';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ApprovalAllSearchComponent } from '../../components/manual-approval-all-list-wo/approval-all-search/approval-all-search.component';
import { FilterDropdownsComponent } from '../../components/manual-approval-my-list-wo/filter-dropdowns/filter-dropdowns.component';
import { User } from '../../models/user.model';
import { Roles } from '../../auth/Roles';
import { ApprovalL3HeaderComponent } from '../../components/manual-approval-l3-my-list-wo/approval-l3-header/approval-l3-header.component';
import { MyWoStateService } from '../../components/manual-approval-my-list-wo/my-wo-state.service';
import { ManualApprovalHeader } from '../../models/manual-approval-header.model';
import { approvalMyWOFormModel } from '../../form-model/approval-wo.form.model';
import { ManualApprovalTtlMyWoComponent } from '../../components/manual-approval-ttl-my-wo/manual-approval-ttl-my-wo.component';

@Component({
  selector: 'app-list-my-processed-work-orders',
  imports: [
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    ApprovalAllSearchComponent,
    FilterDropdownsComponent,
    ApprovalL3HeaderComponent,
    ManualApprovalTtlMyWoComponent,
  ],
  templateUrl: './list-my-processed-work-orders.component.html',
  styleUrl: './list-my-processed-work-orders.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ListMyProcessedWorkOrdersComponent {
  isAnyRowSelected: boolean = false;
  selectedRows: BulkWorkOrderCompletionBody[] = [];
  selectedTabVal: string = '';
  filterFormGroup = this.formBuilder.group({
    workOrderFilterForm: this.formBuilder.group<ApprovalFilterForm>({} as ApprovalFilterForm),
    workOrderSearchTextForm: this.formBuilder.group<WorkOrderSearchTextForm>({} as WorkOrderSearchTextForm),
  });
  loadedData: ManualApprovalHeader[] = [];
  loadedFormData!: FormGroup<approvalMyWOFormModel>;
  isWorkOrderList = false;
  loggedinUser: User | null = AuthHelper.user;
  isRoleManager: boolean = false;
  isRoleTTLApprover: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private stateService: MyWoStateService,
  ) {}
  ngOnInit() {
    if (this.loggedinUser?.roles.some((role) => role.toLowerCase() === Roles.MANAGER)) {
      this.isRoleManager = true;
    }
    if (this.loggedinUser?.roles.some((role) => role.toLowerCase() === Roles.TTLAPPROVER)) {
      this.isRoleTTLApprover = true;
    }
    if (this.stateService.tabledata) {
      this.loadedData = this.stateService.tabledata;
    }
    if (this.stateService.formData) {
      this.loadedFormData = this.stateService.formData;
    }
  }
  public getLoadedData(data: ManualApprovalHeader[]) {
    this.stateService.tabledata = data;
  }
  public getSearchLoadedData(data: ManualApprovalHeader[]) {
    this.stateService.tabledata = data;
  }
  public getLoadedFormData(data: FormGroup<approvalMyWOFormModel>) {
    this.stateService.formData = data;
  }
  handleSelectedRows(selectedRowsChange: BulkWorkOrderCompletionBody[]) {
    this.selectedRows = selectedRowsChange;
  }
  public tabVal(selectedTab: string) {
    this.selectedTabVal = selectedTab;
  }
}
